import React from "react";
import MicroserviceEventTableHeader from "./components/MicroserviceEventTableHeader";
import MicroserviceEventTableRow from "./components/MicroserviceEventTableRow";
import { MicroserviceEventsProvider } from "./hooks/MicroserviceEventsProvider";
import { useMicroserviceEvents } from "./hooks/useMicroserviceEvents";
import { VirtualTable } from "../../components/tables";
import { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable";

const EventsTableDisplay = () => {
    const {
        clear: refreshTable,
        data,
        error,
        isLoading,
        isNextPageLoading,
        isNewRecords,
        isRowLoaded,
        loadMore,
        newRecordsSinceCache,
        totalCount
    } = useMicroserviceEvents();

    const isNewRecordsDisplayed = isNewRecords && !isLoading && !isNextPageLoading;
    return (
        <VirtualTable 
            enableScrollTracking={false}
            row={MicroserviceEventTableRow}
            header={(
                <thead>
                    <tr>
                        <MicroserviceEventTableHeader property="type">Flow</MicroserviceEventTableHeader>
                        <MicroserviceEventTableHeader property="eventName">Event</MicroserviceEventTableHeader>
                        <MicroserviceEventTableHeader property="eventQueue">Queue</MicroserviceEventTableHeader>
                        <MicroserviceEventTableHeader property="createdDate">Received</MicroserviceEventTableHeader>
                        <MicroserviceEventTableHeader property="handledDate">Handled</MicroserviceEventTableHeader>
                        <MicroserviceEventTableHeader className="text-center" property="totalAttempts">Attempts</MicroserviceEventTableHeader>
                        <th className="sticky-header">&nbsp;</th>
                    </tr>
                </thead>
            )}
            footer={
                <TableRecordCountDisplayFooter 
                    totalCount={totalCount}
                    isNewRecordsDisplayed={isNewRecordsDisplayed}
                    newRecordsSinceCache={newRecordsSinceCache}
                    reload={refreshTable}
                />
            }
            error={error}
            isLoading={isNextPageLoading}
            isItemLoaded={isRowLoaded}
            loadMoreItems={loadMore}
            itemSize={30}
            itemCount={totalCount}
            itemData={data}
        />
    );
};

export const MicroserviceEventsTable = ({ query } : Readonly<{ query: any }>) => (
    <MicroserviceEventsProvider query={query}>
        <EventsTableDisplay />
    </MicroserviceEventsProvider>
)